import "../../styles/atoms.scss";
import SvgIcn from "../../data/IconCompo";
import { useState, useEffect } from "react";

const TextArea = ({
  title,
  iconL = "dots_on",
  placeholder,
  className,
  maxLength = 50,
  value,
  onChange,
  name,
  error,
  onBlur,
  disable,
}) => {
  const [text, setText] = useState(value || "");
  const [isFocused, setIsFocused] = useState(false);
  const [charCount, setCharCount] = useState(0);

  const countCharacters = (str) => {
    return str.split('').reduce((count, char) => {
      return count + (/[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/.test(char) ? 2 : 1);
    }, 0);
  };

  useEffect(() => {
    setCharCount(countCharacters(text));
  }, [text]);

  useEffect(() => {
    setText(value || "");
  }, [value]);

  const handleChange = (e) => {
    const newText = e.target.value;
    const newCount = countCharacters(newText);
    if (newCount <= maxLength) {
      setText(newText);
      setCharCount(newCount);
      onChange && onChange(e.target);
    }
  };

  const remainingCharacters = maxLength - charCount;
  const counterClass = remainingCharacters === 0 ? "char-counter red" : "char-counter";

  return (
    <div className={`input-top-box ${className}`}>
      <div className="left-side">
        {iconL && (
          <span className={`icon left-icon ${isFocused ? "focused" : ""}`}>
            <SvgIcn name={iconL} />
          </span>
        )}
        {title && (
          <div className={`textarea-title ${isFocused ? "focused" : ""}`}>
            {title}
          </div>
        )}
        <div className={counterClass}>{remainingCharacters}</div>
      </div>
      <textarea
        name={name}
        value={value}
        onChange={handleChange}
        onFocus={() => setIsFocused(true)}
        onBlur={(e) => {
          setIsFocused(false);
          onBlur?.(e);
        }}
        className={`input ${error ? "input-error" : ""}`}
        placeholder={placeholder}
        disabled={!!disable}
      />
    </div>
  );
};

export default TextArea;
